import state from './state'

export const windowW = state => state.windowW

export const language = state => state.language

export const product = state => state.product

export const lang = state => state.lang

export const productsH = state => state.productsH

export const prodctList = state => state.prodctList


// WEBPACK FOOTER //
// ./src/store/getters.js